// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Section.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonials-container {
  position: relative;
  padding: 80px 0;
  background-color: #183864;
  overflow: hidden;
}

.testimonials-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.testimonials-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.1;
}

.testimonials-content {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.testimonials-header {
  text-align: center;
  margin-bottom: 60px;
}

.testimonials-title {
  font-size: 3rem;
  font-weight: 800;
  color: white;
  margin-bottom: 20px;
  line-height: 1.2;
}

.testimonials-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.testimonials-slider {
  margin-top: 40px;
}

.testimonials-slider-modern .slick-track {
  display: flex;
  align-items: stretch;
}

.testimonials-slider-modern .slick-slide {
  height: inherit;
}

.testimonials-slider-modern .slick-slide > div {
  height: 100%;
}

.testimonials-slider-modern .slick-slide > div > div {
  height: 100%;
}

.testimonial-card {
  padding: 0 15px;
}

.testimonial-content {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  height: 100%;
}

.testimonial-content:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
}

.testimonial-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 20px;
  border: 3px solid rgba(255, 255, 255, 0.2);
}

.testimonial-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonial-info {
  text-align: center;
}

.testimonial-name {
  font-size: 1.3rem;
  font-weight: 700;
  color: white;
  margin-bottom: 5px;
}

.testimonial-role {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  margin-bottom: 15px;
}

.testimonial-rating {
  margin-bottom: 20px;
}

.star {
  font-size: 1.2rem;
  margin: 0 2px;
}

.testimonial-review {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  line-height: 1.6;
  font-style: italic;
}

/* Modern Slick Carousel Customizations */
.testimonials-slider-modern .slick-dots {
  bottom: -60px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.testimonials-slider-modern .slick-dots li {
  width: 12px;
  height: 12px;
  margin: 0;
}

.testimonials-slider-modern .slick-dots li button {
  width: 12px;
  height: 12px;
  padding: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.testimonials-slider-modern .slick-dots li button:before {
  display: none;
}

.testimonials-slider-modern .slick-dots li.slick-active button {
  background: #B02526;
  transform: scale(1.2);
}

.testimonials-slider-modern .slick-dots li button:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Line clamp utility */
.line-clamp-4 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Responsive Design */
@media (max-width: 768px) {
  .testimonials-title {
    font-size: 2rem;
  }

  .testimonials-subtitle {
    font-size: 1rem;
  }

  .testimonial-content {
    padding: 20px;
  }

  .testimonial-name {
    font-size: 1.1rem;
  }

  .testimonial-review {
    font-size: 0.9rem;
  }
}

.testimonials-BG{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.line-clamp-6 {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/components/testimonials/Testimonials.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".testimonials-container {\n  position: relative;\n  padding: 80px 0;\n  background-color: #183864;\n  overflow: hidden;\n}\n\n.testimonials-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.testimonials-bg-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0.1;\n}\n\n.testimonials-content {\n  position: relative;\n  z-index: 2;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.testimonials-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.testimonials-title {\n  font-size: 3rem;\n  font-weight: 800;\n  color: white;\n  margin-bottom: 20px;\n  line-height: 1.2;\n}\n\n.testimonials-subtitle {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.8);\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.testimonials-slider {\n  margin-top: 40px;\n}\n\n.testimonials-slider-modern .slick-track {\n  display: flex;\n  align-items: stretch;\n}\n\n.testimonials-slider-modern .slick-slide {\n  height: inherit;\n}\n\n.testimonials-slider-modern .slick-slide > div {\n  height: 100%;\n}\n\n.testimonials-slider-modern .slick-slide > div > div {\n  height: 100%;\n}\n\n.testimonial-card {\n  padding: 0 15px;\n}\n\n.testimonial-content {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  height: 100%;\n}\n\n.testimonial-content:hover {\n  transform: translateY(-5px);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.testimonial-image {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin: 0 auto 20px;\n  border: 3px solid rgba(255, 255, 255, 0.2);\n}\n\n.testimonial-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.testimonial-info {\n  text-align: center;\n}\n\n.testimonial-name {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 5px;\n}\n\n.testimonial-role {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.9rem;\n  margin-bottom: 15px;\n}\n\n.testimonial-rating {\n  margin-bottom: 20px;\n}\n\n.star {\n  font-size: 1.2rem;\n  margin: 0 2px;\n}\n\n.testimonial-review {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1rem;\n  line-height: 1.6;\n  font-style: italic;\n}\n\n/* Modern Slick Carousel Customizations */\n.testimonials-slider-modern .slick-dots {\n  bottom: -60px;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.testimonials-slider-modern .slick-dots li {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n}\n\n.testimonials-slider-modern .slick-dots li button {\n  width: 12px;\n  height: 12px;\n  padding: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  transition: all 0.3s ease;\n}\n\n.testimonials-slider-modern .slick-dots li button:before {\n  display: none;\n}\n\n.testimonials-slider-modern .slick-dots li.slick-active button {\n  background: #B02526;\n  transform: scale(1.2);\n}\n\n.testimonials-slider-modern .slick-dots li button:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n/* Line clamp utility */\n.line-clamp-4 {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .testimonials-title {\n    font-size: 2rem;\n  }\n\n  .testimonials-subtitle {\n    font-size: 1rem;\n  }\n\n  .testimonial-content {\n    padding: 20px;\n  }\n\n  .testimonial-name {\n    font-size: 1.1rem;\n  }\n\n  .testimonial-review {\n    font-size: 0.9rem;\n  }\n}\n\n.testimonials-BG{\n  background-image: url(\"../../assets/Section.png\");\n  background-size: cover;\n}\n\n.line-clamp-6 {\n  display: -webkit-box;\n  -webkit-line-clamp: 6;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
